import React from 'react'
import { Link } from 'react-router-dom';
import aboutImg from '../../assets/img/home2/AboutShreegitaImage.png';

const AboutTwo = () => {
  return (
    <section className="about-section section-padding">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-xl-6 col-12 pe-xl-0">
                    <div className="about-cover-bg bg-cover me-xl-5" style={{backgroundImage: `url(${aboutImg})`}}>
                        <div className="our-experience-years">
                            <div className="year-outline">
                                <h2>49</h2>
                            </div>
                            <p>Years <span>Experience</span></p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 mt-5 mt-lg-0 col-12">
                    <div className="block-contents">
                        <div className="section-title">
                            <span>About Shree Gita</span>
                            <h2>Leading with Quality, Driven by Trust</h2>
                        </div>
                        <blockquote>Empowering Industries with Premium Agricultural and Industrial Solutions</blockquote>
                    </div>

                    <p>At Shree Gita Group, we are pioneers in the agricultural and industrial sectors, offering a diverse range of high-quality products including raw cotton, edible oils, oilseeds, and more. With decades of experience, we have built a reputation for reliability, innovation, and customer satisfaction. 

From sourcing premium raw materials to processing and delivering refined goods, we are committed to meeting the needs of our global clientele while upholding the highest standards of quality and sustainability.  </p>

                    {/* <Link to="/warehouse" className="theme-btn mt-35"> Gold Coin Where Housing  </Link> */}
                </div>
            </div>
        </div>
        <h2 className="section-rotate-title d-none d-xxl-block">ABOUT</h2>
    </section>
  )
}

export default AboutTwo